import React from 'react'

const CommonPosCheckout = () => {
    return <div>CommonPosCheckout</div>
}

export default CommonPosCheckout
